import React, { useState } from 'react';

export interface ToggleOption {
  label: string;
  value: string;
}

interface ToggleProps {
  wrapperClassName?: string;
  debounce?: number;
  disabled?: boolean;
  firstButtonClassName?: string;
  onChange: (value: string) => void;
  options: ToggleOption[];
  secondButtonClassName?: string;
  value?: string;
}

// eslint-disable-next-line max-len
const SHARED_CLASSES = 'tw-border tw-border-solid tw-border-tci-purple tw-p-1.5 enabled:tw-cursor-pointer tw-w-full tw-text-lg';
// eslint-disable-next-line max-len
const BASE_BUTTON_CLASS = `${SHARED_CLASSES} tw-bg-white enabled:hover:tw-bg-tci-purple enabled:hover:tw-text-white tw-text-tci-purple`;
const SELECTED_BUTTON_CLASS = `${SHARED_CLASSES} tw-bg-tci-purple tw-text-white`;

const Toggle = ({
  wrapperClassName,
  debounce = 0,
  disabled = false,
  firstButtonClassName,
  onChange,
  options,
  secondButtonClassName,
  value,
}: ToggleProps) => {
  const [toggled, setToggled] = useState(false);
  const isDisabled = disabled || toggled;

  const handleToggle = (newValue: string) => {
    if (isDisabled) return;

    setToggled(true);
    if (debounce > 0) {
      setTimeout(() => setToggled(false), debounce);
    } else {
      setToggled(false);
    }

    onChange(newValue);
  };

  const getButtonClassName = (option: ToggleOption, index: number) => {
    const baseClass = value === option.value ? SELECTED_BUTTON_CLASS : BASE_BUTTON_CLASS;

    if (index === 0 && firstButtonClassName) {
      return `${baseClass} ${firstButtonClassName}`;
    }

    if (index === 1 && secondButtonClassName) {
      return `${baseClass} ${secondButtonClassName}`;
    }

    return baseClass;
  };

  return (
    <div className={wrapperClassName}>
      {options.map((option, index) => (
        <button
          key={option.value}
          className={getButtonClassName(option, index)}
          disabled={isDisabled}
          type="button"
          onClick={() => handleToggle(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default Toggle;
